import { render } from "./GameContainer.vue?vue&type=template&id=2ad5e03e"
import script from "./GameContainer.vue?vue&type=script&lang=js"
export * from "./GameContainer.vue?vue&type=script&lang=js"

import "./GameContainer.vue?vue&type=style&index=0&id=2ad5e03e&lang=css"

import exportComponent from "/tmp/builds/1syD-sny/0/plataforma/frontend/side_panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__